export default ['MagazinesList', 'MagazineView', 'MagazineEdit']
